/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Coach_CtaInputs */

const en_portal_coach_cta = /** @type {(inputs: Portal_Coach_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to the coach app`)
};

const pl_portal_coach_cta = /** @type {(inputs: Portal_Coach_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź do aplikacji trenera`)
};

/**
* | output |
* | --- |
* | "Go to the coach app" |
*
* @param {Portal_Coach_CtaInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_coach_cta = /** @type {((inputs?: Portal_Coach_CtaInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Coach_CtaInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_coach_cta(inputs)
	return en_portal_coach_cta(inputs)
});